const DIRECTION_PATIENT_FIELD_KEYS = [
  'examineName',
  'sickName',
  'age',
  'IIN',
  'homeAdress',
  'workPlace',
];

export const getPatientFullName = (patient) => {
  if (!patient) return '';
  if (patient.fullName) return patient.fullName;
  return [patient.lastName, patient.firstName, patient.secondName]
    .filter(Boolean)
    .join(' ');
};

export const getPatientAge = (patient) => {
  if (!patient) return '';

  if (patient.yearsOld != null && patient.yearsOld !== '') {
    return String(patient.yearsOld);
  }

  if (patient.birthDate) {
    const birth = new Date(patient.birthDate);
    if (Number.isNaN(birth.getTime())) return '';

    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      age -= 1;
    }
    return String(age);
  }

  return '';
};

const buildDirectionPatientFieldValues = (patient) => {
  const fullName = getPatientFullName(patient);

  return {
    examineName: fullName,
    sickName: fullName,
    age: getPatientAge(patient),
    IIN: patient?.identityNumber ?? '',
    homeAdress: patient?.addressLine ?? '',
    workPlace: patient?.placeOfWorkOrEducation ?? '',
  };
};

const setDirectionField = (data, key, value) => ({
  ...data,
  [key]: { key, value: value ?? '' },
});

export const fillDirectionDataFromPatient = (currentData, patient) => {
  const nextData = { ...(currentData || {}) };

  if (!patient) {
    return nextData;
  }

  const fieldValues = buildDirectionPatientFieldValues(patient);

  DIRECTION_PATIENT_FIELD_KEYS.forEach((key) => {
    nextData[key] = setDirectionField(nextData, key, fieldValues[key])[key];
  });

  return nextData;
};
